
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from 'styled-components';
import EventIcon from '@material-ui/icons/Event';
import { ModuleBase } from '@loanbossinc/component-library';
import { mapModulePermissions, reminderGetByDeal } from './reminder.store';
import { withRouter } from "react-router";
import moment from "moment";
import pluralize from 'pluralize';
import {
  SecondaryButton
  , DefaultModuleHeader
  , TableDefault
  , LabelString
  , ButtonIcon
  , ButtonSizeOptions
  , ModuleEmptyButton
} from '@loanbossinc/component-library';

// NOTE: THIS IS INTENTIALLY IMPORTING FROM components AND **NOT** component-lib!!!!!!
// TODO: REDO THIS MODAL
import AddEditAlert from "components/Notifications/AddEditAlert";

const StyledTable = styled(TableDefault)`
  && {
    box-shadow: none;
    border-radius: 8px;

    .cell-message {
      border-left: 1px solid rgba(224, 224, 224, 1);
    }

    .cell-edit {
      width: 32px;
      button {
        margin-left: auto;
        border: none !important;
    
        .material-icons {
          font-size: 18px; 
        }
      }
    }
  }
`;

const StyledMessageCell = styled.div`
  && {
    display: flex;
    align-items: center;
    flex: 1;
  }
`;

const ADD_EDIT_ALERT_MODAL = 'ADD_EDIT_ALERT_MODAL';

class ReminderModule extends React.Component {
  state = {
    selectedReminderId: null
    , openModal: { name: null, data: null }
  }

  columns = [
    {
      id: 'testValue'
      , label: 'Test Value'
      , path: 'testValue'
      , Cell: (value) => {
        if (!!value) value = moment(value, 'L').format('LL');
        return (
          <LabelString value={value} />
        );
      }
    }
    , {
      id: 'message'
      , label: 'Message'
      , path: 'alertDefinition.message'
      , Cell: (value) => (
        <StyledMessageCell>
          <LabelString value={value} />
        </StyledMessageCell>
      )
    }
    , {
      id: 'edit'
      , label: 'edit'
      , path: 'alertDefinitionId'
      , Cell: (value) => (
        <ButtonIcon
          hasBorder
          iconName="edit"
          onClick={() => this.handleReminderEdit(value)}
        />
      )
    }
  ];

  handleReminderEdit = (selectedReminderId) => {
    this.updateReminders();

    this.setState({
      ...this.state
      , selectedReminderId
      , openModal: { name: ADD_EDIT_ALERT_MODAL }
    });
  }

  componentDidMount() {
    this.updateReminders();
  }

  updateReminders = () => {
    const { dealId } = this.props.match.params;
    this.props.reminderGetByDeal({ dealId });
  }

  getSubTitle = () => {
    const { reminders } = this.props;
    if (!reminders.length) return "Add a reminder to this deal";
    const currentDate = new Date().setHours(0, 0, 0, 0);
    const dayCount = moment(reminders[0].testValue, "L").diff(currentDate, "days");
    if (dayCount === 0) {
      return "The next reminder will trigger today.";
    }
    return `The next reminder will trigger in ${dayCount} day${dayCount === 1 ? "" : "s"}.`;
  }

  getHeaderButton = () => {
    const { reminders } = this.props;
    const label = reminders.length > 3 ? "Show All" : "Add Reminder";

    return (
      <SecondaryButton
        label={label}
        size={ButtonSizeOptions.smFluid}
        onClick={() => this.openModal(ADD_EDIT_ALERT_MODAL)}
      />
    );
  }

  closeModal = () => {
    this.setState({ openModal: { name: null, data: null } });
    this.updateReminders();
  };

  openModal = (name, data = null) => this.setState({ openModal: { name, data } });
  isModalOpen = (modalName) => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  }

  renderEmptyModule = () => {
    const { reminders } = this.props;

    if (!reminders || !reminders.length) return (
      <ModuleEmptyButton className="module"
      style={{ marginTop: '2em', width: '648px' }}
        label="Add a reminder"
        iconName={<EventIcon />}
        onClick={() => this.handleReminderEdit(null)}
      />
    );
  }

  renderModule = () => {
    const { reminders, modulePermissions } = this.props;
    if (!modulePermissions || !modulePermissions.canViewModule) return null;

    if (reminders && reminders.length) return (
      <ModuleBase>
        <DefaultModuleHeader
          headerElement={[<EventIcon />]}
          headerTitle={`${reminders.length || 'No'} ${pluralize('Reminder', reminders.length)}`}
          subTitle={this.getSubTitle()}
          button={this.getHeaderButton()}
        />

        <StyledTable
          columns={this.columns}
          hideHeader
          items={reminders.slice(0, 3)}
        />
      </ModuleBase>
    );
  }

  render() {
    const { selectedReminderId } = this.state;
    let dealId = this.props.match.params.dealId
    if(this.props.match.params.dealId && typeof this.props.match.params.dealId === "string")
      dealId = parseInt(this.props.match.params.dealId);
      
    return (
      <>
        {this.renderEmptyModule()}
        {this.renderModule()}

        <AddEditAlert
          key={dealId}
          dealId={dealId}
          notificationId={selectedReminderId}
          isOpen={this.isModalOpen(ADD_EDIT_ALERT_MODAL)}
          handleCancel={this.closeModal}
          handleSave={this.closeModal}
          isAlert={false}
          isNew={!!selectedReminderId}
        />
      </>
    );
  }
}

const mapStateToProps = ({ reminderModule, authentication }) => ({
  ...reminderModule
  , ...reminderModule.reminderModuleReducer
  , modulePermissions: mapModulePermissions(authentication)
});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    reminderGetByDeal
  })
)(ReminderModule);
